import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import Home from '../views/Home.vue'
import Categories from '../views/Categories.vue'
import Expenses from '../views/Expenses.vue'
import Report from '../views/Report.vue'
import { getBrowserLocale, DEFAULT_LOCALE, LOCALES } from '../plugins/i18n'
// Nếu muốn lấy locale mặc định từ i18n, có thể import như sau:
// import { DEFAULT_LOCALE } from '../plugins/i18n'

// Lấy locale mặc định từ trình duyệt, nếu không có thì fallback về DEFAULT_LOCALE
const getDefaultLocale = () => getBrowserLocale() || DEFAULT_LOCALE

// Danh sách các locale hợp lệ
const validLocales = Object.values(LOCALES)

// Các route con cho từng locale
const localeChildRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'Home',
    component: Home
  },
  {
    path: 'categories',
    name: 'Categories',
    component: Categories,
    meta: {
      roles: ['admin', 'editor', 'DEFAULT_ROLE']
    }
  },
  {
    path: 'expenses',
    name: 'Expenses',
    component: Expenses,
    meta: {
      roles: ['admin', 'editor', 'DEFAULT_ROLE']
    }
  },
  {
    path: 'report',
    name: 'Report',
    component: Report,
    meta: {
      roles: ['admin', 'editor', 'DEFAULT_ROLE']
    }
  }
]

// Route riêng cho account-holders
const accountHoldersRoute: RouteRecordRaw = {
  path: '/account-holders',
  name: 'account-holders',
  component: () => import('../views/AccountHolders.vue'),
  meta: {
    title: 'Quản lý chủ tài khoản',
    icon: 'UserFilled',
    roles: ['admin']
  }
}

const routes: RouteRecordRaw[] = [
  // Redirect trang chủ theo locale
  {
    path: '/',
    redirect: () => `/${getDefaultLocale()}`
  },
  
  // Chỉ chấp nhận locale hợp lệ (en hoặc vi)
  {
    path: '/:locale(' + validLocales.join('|') + ')',
    component: () => import('../components/LocaleRouter.vue'),
    children: localeChildRoutes
  },
  
  // Thêm route account-holders riêng (không phải là con của locale)
  accountHoldersRoute,
  
  // Các route không hợp lệ redirect về trang chủ
  {
    path: '/:pathMatch(.*)*',
    redirect: '/' // fallback về locale mặc định
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
